var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slice",class:[_vm.$data.bootstrap.size, _vm.$data.bootstrap.format]},[_c('b-container',{staticClass:"wrapper",attrs:{"fluid":_vm.fluid}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }